export const APP_NAME = "Clutch";
export const APP_SHORT_NAME = "Clutch";
export const APP_DESCRIPTION =
	"Mission-driven tournament management platform for tournament directors, coaches, and athletes building healthier local sports communities.";

// Canvas / body background — must match CSS --background exactly so safe-area
// padding and the visible header read as one continuous block.
export const APP_BG_LIGHT = "#ffffff";
export const APP_BG_DARK = "#0a0a0a";

// Status-bar theme-color — match APP_BG_* exactly. The thin line we were
// chasing turned out to be Chrome's PWA loading indicator (device/browser-
// level, not an Android contrast divider), so the offset hack served no
// purpose. Keeping these aligned means the safe-area pad and the visible
// header read as one continuous block.
export const APP_THEME_COLOR_LIGHT = APP_BG_LIGHT;
export const APP_THEME_COLOR_DARK = APP_BG_DARK;

// Manifest splash uses single-value spec; no contrast-divider concern there.
export const APP_THEME_COLOR = APP_THEME_COLOR_LIGHT;
export const APP_BACKGROUND_COLOR = APP_BG_LIGHT;
export const APP_DARK_BACKGROUND_COLOR = APP_THEME_COLOR_DARK;
